import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'postscribe';
import 'intersection-observer';
import 'promise-polyfill';
import 'scroll-behavior-polyfill';
import 'url-polyfill';
import './helper';
import { ComponentFactory } from './ComponentFactory';
import { GlobalMessage } from './GlobalMessage';
import { GlobalMessageHandler } from './GlobalMessageHandler';
import { LazyLoader } from './LazyLoader';
import { ModalManager } from './ModalManager';
import { Page } from './Page';
import { PageStart } from './PageStart';
import { Utilities } from './Utilities';
import './polyfills/nodelist-foreach.ts';
import './polyfills/classlist-foreach.ts';
import './polyfills/custom-event.ts';
import './polyfills/object-assign.ts';
import tippy from 'tippy.js';
// Define all classes which should be exposed to the global
// scope for picker, widgets and additional scripts
window.ComponentFactory = ComponentFactory;
window.LazyLoader = LazyLoader;
window.GlobalMessage = GlobalMessage;
window.GlobalMessageHandler = GlobalMessageHandler;
window.Utilities = Utilities;
window.tippy = tippy;
new PageStart();
jQuery(function () {
    window.PageInstance = new Page();
    window.modalManager = new ModalManager();
    tippy('[data-tippy-content]', {
        arrow: true,
        placement: 'top',
        theme: 'pgb-tips',
    });
    window.dispatchEvent(new Event('page_ready'));
});
